// extracted by mini-css-extract-plugin
export default {"container":"EditTechnician_container__5vvgX","progressContainer":"EditTechnician_progressContainer__UPb71"};